<template>
  <div class="page__bd bm" id="list">
    <toobarhead :showRefresh="false" :showBack="true" :showMore="false" :titleName="'详情'"></toobarhead>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label">标题&nbsp;&nbsp;</label></div>
        <div class="weui-cell__bd">
          {{ sealOut.title }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">申请人&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ sealOut.owner }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">印章所属公司&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ sealOut.companyName }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">所需印章&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ seal }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">借出部门&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ sealOut.departmentName }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">印章借出人&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ sealOut.director }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">借出人电话&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ sealOut.directorTel }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">预计借出时间&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ outTime }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">预计归还时间&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ returnTime }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">创建时间&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ createtime }}
        </div>
      </div>
          <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">备注&nbsp;&nbsp;</label>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <textarea class="weui-textarea" placeholder="无备注内容" rows="2" readonly="" v-model="sealOut.comment"></textarea>
        </div>
      </div>
    </div>
    <div class="fd">
      <div class="fd_l fl" @click.prevent='detail(sealOut.id)'>
        <a class="btn_batch_repay" @click.prevent>审批详情</a>
      </div>
      <div class="fd_r fr" v-show="showRevoke" @click.prevent='confirmRevoke()'>
        <a class="btn_batch_repay" @click.prevent>审核撤回</a>
      </div>
      <div class="fd_r fr" v-show='showAuditBtn' @click.prevent='audit(sealOut.id)'>
        <a class="btn_batch_repay" @click.prevent>审核</a>
      </div>
    </div>
    <div class="dialogs">
      <div class="js_dialog" id="revokeConfirm" style="display: none;">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
          <div class="weui-dialog__hd"><strong class="weui-dialog__title">确认撤回</strong></div>
          <div class="weui-dialog__bd">确定进行撤回的操作吗</div>
          <div class="weui-dialog__ft">
            <a class="weui-dialog__btn weui-dialog__btn_default" @click.prevent="cancelRevoke">放弃</a>
            <a class="weui-dialog__btn weui-dialog__btn_primary" @click.prevent="revoke()">确定</a>
          </div>
        </div>
      </div>
      <div class="js_dialog" v-show="showtip">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">提示</strong></div>
        <div class="weui-dialog__bd">{{tipContent}}</div>
        <div class="weui-dialog__ft">
            <a @click.prevent.stop='goBack' class="weui-dialog__btn weui-dialog__btn_primary">知道了</a>
        </div>
      </div>
    </div>
    <div class="js_dialog showNoAttachTip" v-show="showNoAttachTip">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">操作被终止</strong></div>
        <div class="weui-dialog__bd">当前没有生成可查看附件，请在电脑端登录系统查看</div>
        <div class="weui-dialog__ft">
            <a @click.prevent.stop='gotit' class="weui-dialog__btn weui-dialog__btn_primary">知道了</a>
        </div>
      </div>
    </div>
    </div>
    <transition name="slide-fade">
      <div v-if='showOperateSuccessToast'>
        <div class="weui-toast">
          <i class="weui-icon-success-no-circle weui-icon_toast"></i>
          <p class="weui-toast__content">已完成</p>
        </div>
      </div>
    </transition>
    <div v-if='showProcessToast'>
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">操作中...</p>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import toobarhead from './head'
  export default {
    computed: {
      ...mapGetters([
        'currentSealOut'
      ]),
      currentOp () {
        return this.$route.params.op
      },
      backOp () {
        return this.$route.params.op
      },
      isRead () {
        return this.sealOut.isRead
      },
      hasAuditRevoke () {
        return this.sealOut.hasAuditRevoke
      },
      state () {
        return this.sealOut.state
      },
      backTitle () {
        return '印章信息'
      },
      showAuditBtn () {
        return this.currentOp === 'audit'
      },
      showRevoke () {
        return this.currentOp === 'history' && !this.isRead && this.state !== 10 && this.hasAuditRevoke
      },
      seal () { // 转换印章显示
        if (!this.sealOut['sealList']) return ''
        return this.sealOut.sealList.map(selSel => selSel['name']).toString()
      },
      createtime () { // 转换创建时间
        if (!this.sealOut['createTime']) return ''
        return new Date(this.sealOut.createTime).toLocaleString()
      },
      outTime () {
        if (!this.sealOut['outTime']) return ''
        return new Date(this.sealOut.outTime).toLocaleString()
      },
      returnTime () {
        if (!this.sealOut['returnTime']) return ''
        return new Date(this.sealOut.returnTime).toLocaleString()
      }
    },
    data () {
      return {
        sealOut: {},
        content: '',
        path: '',
        image: [],
        showOperateSuccessToast: false,
        showProcessToast: false,
        showtip: false,
        tipContent: '',
        pb2: null // 图片浏览器
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        let vm = this
        let route = this.$route
        if (vm.currentSealOut === null) {
          var data = {
            op: vm.currentOp
          }
          if (route.query.orderId) {
            data['orderId'] = route.query.orderId
          }
          if (route.query.taskId) {
            data['taskId'] = route.query.taskId
          }
          if (route.query.taskName) {
            data['taskName'] = route.query.taskName
          }
          vm.findSealOut({
            id: route.params.sealOutId,
            data: data
          }).then(c => {
            vm.sealOut = c
          }).catch(errMsg => {
            vm.tipContent = errMsg
            vm.showtip = true
          })
        } else {
          vm.sealOut = vm.currentSealOut
        }
      })
    },
    watch: {
      sealOut: function (val) {
      }
    },
    components: {
      toobarhead
    },
    beforeDestroy () {
      if (this.pb2) {
        this.pb2.close()
      }
    },
    methods: {
      ...mapActions([
        'findSealOut'
      ]),
      gotit: function () {
        this.showNoAttachTip = false
      },
      goBack: function () {
        let vm = this
        setTimeout(function () {
          vm.$router.push({path: '/listSealOut/' + vm.backOp, query: {showNavbar: vm.$route.query.showNavbar, showBack: false, tname: vm.backTitle, refresh: true, selected: vm.$route.query.selected}})
        }, 200)
      },
      audit: function (sealOutId) {
        this.$router.push({path: '/auditSealOut/' + this.sealOut.id, query: {orderId: this.sealOut.orderId, taskId: this.sealOut.taskId, taskName: this.sealOut.taskName}})
      },
      detail: function (sealOutId) {
        this.$router.push({path: '/logSealOut/' + this.sealOut.id, query: {risk: this.sealOut.risk}})
      },
      confirmRevoke () {
        window.$('#revokeConfirm').fadeIn(100)
      },
      revoke () {
        let revokeType
        let vm = this
        // let route = vm.$route
        if (this.sealOut.taskName === 'apply') {
          // 申请撤回
          revokeType = 18
        } else {
          // 审核撤回
          revokeType = 15
        }
        this.$http.post('rest/api/revokeSealOut/' + this.sealOut.id, {taskId: this.sealOut.taskId, revokeType: revokeType, processType: this.sealOut.processType}).then(function (response) {
          vm.showProcessToast = false
          if (response.data.ok) {
            vm.showOperateSuccessToast = true
            setTimeout(function () {
              vm.showOperateSuccessToast = false
              setTimeout(function () {
                vm.goBack()
              }, 200)
            }, 700)
          } else {
            vm.tipContent = response.data.msg
            vm.showtip = true
          }
        }, function (response) {
          window.$('#sealConfirm').fadeOut(200)
          vm.showProcessToast = false
        })
      },
      cancelRevoke: function () {
        window.$('#revokeConfirm').fadeOut(200)
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {})
    },
    beforeRouteLeave (to, from, next) { // 导航离开该组件的对应路由时调用
      var vm = this
      if (vm.pb2) {
        vm.pb2.close()
        vm.pb2 = null
        next(false)
        return
      }
      next(true)
    }
  }
</script>
<style>
  .fd {
    position: fixed;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #eee;
    background-color: #fff;
    z-index: 1;
  }
  .fd_r {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #eaeaea;
    float: right;
  }
  .fd_l {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #eaeaea;
    float: left;
  }
  .bm {
    margin-bottom: 40px
  }
  .weui-cells__title {
    color: #999999
  }
  .attach{
    font-size: 18px;
    font-weight: bold
  }
  iframe{
    margin: 5px auto;
  }
  .close-popup-btn{
    width: 50%;
    margin: 2px auto
  }
</style>



// WEBPACK FOOTER //
// sealOut.vue?4ba491eb